import React, { useState, useEffect, useRef } from 'react'
import {Form, Button, DropdownButton, Dropdown, ProgressBar, Check, Modal, Tabs, Tab} from "react-bootstrap";
import Switch from "react-switch";
import axios from 'axios';
import * as signalR from "@microsoft/signalr";
import '../Account.css';
import {useTranslation} from "react-i18next";


function MainSettings({drone}){
    const { t } = useTranslation(['modem']);

    const protocol = new signalR.JsonHubProtocol();
    const transport = signalR.HttpTransportType.WebSockets;

    const [rateHub, setRateHub] = useState(hubConnect);
    const [showUnbindModel, setShowUnbindModel] = useState(false);
    const [modemSettings, setModemSettings] = useState(null);
    const [rtspStr, setRtspStr] = useState(null);
    const [fpvModeSettings, setFpvModSettings] = useState(false);
    const [fpvLatencySettings, setFpvLatencySettings] = useState("400");
    const [saveSettingsInfo, setSaveSettingsInfo] = useState(<></>);
    const [enabledSaveButton, setEnabledSaveButton] = useState(false);

    const [firmwareLoad, setFirmwareLoad] = useState(<></>);
    const [firmwareLoadState, setFirmwareLoadState] = useState(0);
    const [firmwareLoadProgress, setFirmwareLoadProgress] = useState(null);

    const [rate, setRate] = useState(null);

    const mimei = useRef("");

    useEffect(() => {
        return () => {
            rateHub.stop();
        };
    }, []);

    useEffect(() => {
        setRate(null);
        setModemSettings(null)
        setSaveSettingsInfo(<></>)
        mimei.current = drone.imei;
        getModemSettings(drone.imei)
        setFirmwareLoad(<></>);
    }, [drone]);

    useEffect(() => {
        setSaveSettingsInfo(<></>);
        setEnabledSaveButton(true);
    }, [modemSettings, rtspStr, fpvModeSettings, fpvLatencySettings]);

    function hubConnect(){
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;

        connection.on('BaudRate', (message) => {
            if(mimei.current === message.imei){
                setRate(message.baudRate)
            }            
        });

        connection.on('FirmwareProgress', (message) => {
            if(mimei.current === message.imei){
                setFirmwareLoadState(message.progress);
                setFirmwareLoadProgress(<>
                    <ProgressBar now={message.progress} label={`${message.progress}%`} />
                </>);
                if(message.progress == 100){
    
                }
            }
            else{
                //console.log("imei !== imei")
            }
                
        });

        connection.start();
        return connection;
    }

    function unbind(){
        setShowUnbindModel(true)
    }
    
    function setBaudRate(value){
        axios.post('api/drone/setBaudRate', {baudRate: value, imei: drone.imei})
            .then(response => {
                console.log(response);
                if(response.data.state == "Ok"){
                    
                }
                if(response.data.state == "ModemNotOnline"){
                    /*setFirmwareLoad(<>
                        <p>Modem not online</p>
                    </>);*/
                }
            });
    }

    function saveModemSettings() {
        axios.post('api/modemSettings/saveSettings', {imei: drone.imei, rtspUrl: rtspStr, fpvMode: fpvModeSettings, fpvLatency: fpvLatencySettings.toString()})
            .then(response => {setSaveSettingsInfo(<label>Настройки сохранены</label>); setEnabledSaveButton(false);})
            .catch((error) => {
                console.log(error.response);
                setSaveSettingsInfo(<label>Ошибка сохранения настроек</label>)
            });
    }

    function getModemSettings(imei) {
        axios.get('api/modemSettings/settings?imei=' + imei)
            .then(response => {console.log("modem settings:"); 
                console.log(response.data);
                setModemSettings(response.data);
                setRtspStr(response.data?.rtspUrl);
                setFpvModSettings(response.data?.fpvMode); 
                setFpvLatencySettings(response.data?.fpvLatency);
            });
    }

    function confirmUnbind(){
        axios.post('api/drone/unbindModem', {imei: drone.imei})
        .then(response => {
            console.log(response);
            window.location.reload();
        });
    }

    function normalizeFirwareVersion(version){
        if(drone.version < 2002){
            var ver = version.toString()
            if(ver.length >= 3){
                var str1 = ver.substring(0,1)
                var str2 = ver.substring(1,2)
                var str3 = ver.substring(2,ver.length)
                return str1 + "." + str2 + "." + str3
            } else {
                return version;
            }
        }
        else 
        {
            // 00 00 00 00
            var patch = (version & 0x000000ff) >> 8 * 0;
            var minor = (version & 0x0000ff00) >> 8 * 1;
            var major = (version & 0x00ff0000) >> 8 * 2;

            return major + "." + minor + "." + patch;
        }
    }

    function loadLastFirmware(){
        axios.post('api/drone/uploadfirmware', {imei: drone.imei})
            .then(response => {console.log(response);
                if(response.data.state == "Ok"){
                    if(drone.version < 2002) {
                        setFirmwareLoad(<>
                            <p>Load firware: {firmwareLoadState}%</p>
                        </>);
                    } else {
                        setFirmwareLoad(<>
                            <p>{t('firmware_in_process_updating')}</p> 
                        </>);
                    }
                }
                if(response.data.state == "NotPressedBind"){
                    setFirmwareLoad(<>
                        <p>Not pressed bind</p>
                    </>);
                }

                if(response.data.state == "ModemNotOnline"){
                    setFirmwareLoad(<>
                        <p>Modem not online</p>
                    </>);
                }
            });
    }

    return(
        <>
        <div className='baud_rate'>
            {rate != null && drone.version < 2000 ? <p style={{marginBottom: "0px"}}>Baud rate: </p> : <></> }
            {rate != null && drone.version < 2000 ? 
            <>
                <DropdownButton id="dropdown-basic-button" title={rate}>
                    <Dropdown.Item onClick = {() => setBaudRate(0)}>9600</Dropdown.Item>
                    <Dropdown.Item onClick = {() => setBaudRate(1)}>57600</Dropdown.Item>
                    <Dropdown.Item onClick = {() => setBaudRate(2)}>115200</Dropdown.Item>
                </DropdownButton>
            </>
            :   
            <></> }
        </div>

        {modemSettings?.rtspUrl == null ? <></> :
        <> 
        <div className='settings-grid ts-16' style={{alignItems: "baseline"}}>
            <div className='grid-2 t-18'>Основные настройки</div>
            <div className='grid-3-6'>
                <div className='t-18 ts-16'>RTSP</div>
                <Form.Control className='input_settings' type="text" value={rtspStr} onChange={(event) => {setRtspStr(event.target.value)}} />
                <div className='t-14 t-gray ts-40'>Строка RTSP подключения к ip камере</div>
                <div className='grid-fpv'>
                    <div className='t-18'>
                        FPV Режим
                    </div>
                    <div className='ogn-switch'>
                        <Switch onChange={() => setFpvModSettings(!fpvModeSettings)} checked={fpvModeSettings} uncheckedIcon={false} checkedIcon={false} onColor='#EBFF00' onHandleColor='#000000' offHandleColor='#000000' offColor='#494949'/>
                    </div>
                </div>
                <div className='t-14 t-gray ts-16'>Уменьшает задержку, но может повлиять на качество изображения</div>
                {
                    fpvModeSettings ? <>
                        <Form.Control key='fpvLat' className='input_settings' type="number" value={fpvLatencySettings} onChange={(event) => {setFpvLatencySettings(event.target.value)}} />
                        <div className='t-14 t-gray ts-16'>Задержка мс</div>
                    </>:<></>
                }
                
            </div>
            <div className='grid-2'>{saveSettingsInfo}</div>
            <Button style={{marginTop: "20px", marginBottom: "12px"}} onClick={saveModemSettings} disabled={!enabledSaveButton}>Сохранить</Button>
            <div className='grid-max'>
                <hr/>
            </div>
            
        </div>
        </>}
        <div className='settings-grid ts-16' style={{alignItems: "baseline"}}>
            <div className='grid-2 t-18'>Прошивка</div>
            <div className='grid-3-6'>
                <p>{t('firmware_version')}: {normalizeFirwareVersion(drone.firmwareVersion)}</p>
                {firmwareLoad}
                    <p></p>
                    {firmwareLoadProgress}
                    { drone.upgradable ? 
                        <>
                            <p>Для обновления ПО выполните следующие 4 шага:</p>
                            <div className='upgrade_steps'>
                                <p>1. Скачайте <a href={drone.upgradeUrl}>архив</a> с образом</p>
                                <p>2. Скачайте <a href="https://win32diskimager.org/">Win32 Disk Imager</a></p>
                                <p>3. Запишите образ sdcard.img (файл находится в архиве) на SD карту с помощью Win32 Disk Imager</p>
                                <p>4. Вставьте SD карту в Air-link и дождитесь операции прошивки (индикатор STATUS мерцает белым цветом), после завершения прошивки загорится зеленый или красный индикатор. Если индикатор красный, попробуйте повторить процесс</p>
                            </div>
                        </> 
                        : 
                        <>
                            {drone.isLastFirmware == 0 ? 
                                <p>{t('latest_firmware_version_is_installed')}</p> 
                                : 
                                <> 
                                    {firmwareLoadProgress != null ?
                                        <></>
                                        :
                                        <>
                                            {drone.isLastFirmware == 1 ? <>
                                                <p>{t('firmware_version_is_outdated')}</p> 
                                                <Button variant="primary" style={{marginBottom: "12px"}} onClick={() => {loadLastFirmware()}}>
                                                    {t('load_latest_version')}
                                                </Button>
                                            </>
                                            :
                                            <>
                                                <p>{t('firmware_in_process_updating')}</p> 
                                            </>
                                            }
                                        </>   
                                    }
                                    
                                </>
                            }
                        </>
                    }
            </div>
        </div>
        <div className='grid-max'>
            <hr/>
        </div>
        <div className='settings-grid ts-16' style={{alignItems: "baseline"}}>
            {drone != null ? 
                <Button variant="primary" onClick={unbind}>Отвязать</Button>
                :
                <></>
            }
        </div>
        

        <Modal  show={showUnbindModel} onHide={() => {setShowUnbindModel(false)}}>
            <Modal.Header closeButton>
            <Modal.Title style={{color: "black"}}>{t('caution')}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{color: "black"}}>{t('are_you_sure_unbind')}</Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={() => {setShowUnbindModel(false)}}>
                {t('close')}
            </Button>
            <Button variant="primary" onClick={confirmUnbind}>
                {t('unbind')}
            </Button>
            </Modal.Footer>
        </Modal>
    </>
    )
}

export default MainSettings;
